import { render } from "./group-list.vue?vue&type=template&id=4fd7b1be&scoped=true&ts=true"
import script from "./group-list.vue?vue&type=script&lang=ts"
export * from "./group-list.vue?vue&type=script&lang=ts"

import "./group-list.vue?vue&type=style&index=0&id=4fd7b1be&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd7b1be"]])

export default __exports__